import CoursesPage from '../../js/pages/CoursesPage';

export default CoursesPage;
